module.exports = __webpack_public_path__ + "img/zip-code-img.f98fabd3.svg";